import { WORLD_W, WORLD_H, RECTS } from './engine/constants';

// Maps the fixed world space into CSS pixels for a given canvas size. Both the
// WebGL renderer and the DOM HUD overlay call this so they line up exactly.
export function computeLayout(cssW, cssH) {
  const padX = Math.max(8, cssW * 0.025);
  const padY = Math.max(8, cssH * 0.025);
  const scale = Math.min(
    (cssW - padX * 2) / WORLD_W,
    (cssH - padY * 2) / WORLD_H,
  );
  const ox = (cssW - WORLD_W * scale) / 2;
  const oy = (cssH - WORLD_H * scale) / 2;

  const toPx = (r) => ({
    x: ox + r.x * scale,
    y: oy + (WORLD_H - r.y - r.h) * scale,
    w: r.w * scale,
    h: r.h * scale,
  });

  const board = toPx(RECTS.board);

  return {
    scale,
    ox,
    oy,
    board,
    hold: toPx(RECTS.hold),
    score: toPx(RECTS.score),
    next: RECTS.next.map(toPx),
    // Top-left pixel of a board cell (col/row in board coordinates).
    cellToPx: (col, row) => ({ x: ox + col * scale, y: oy + row * scale }),
    // World-space point (y up) to pixels.
    worldToPx: (wx, wy) => ({ x: ox + wx * scale, y: oy + (WORLD_H - wy) * scale }),
  };
}
